import axios from "../../axios-config";
import { showToast } from "../../helper/ShowToast";

const handleError = (toast, error) => {
    const message = error.response?.data?.message || error.message;
    const status = error.response?.status;

    if ([400, 401, 403, 500].includes(status)) {
        showToast("error", message);
    } else {
        showToast("error", message);
    }
};

export const startCreateTask = () => {
    return {
        type: 'STARTCREATETASK',
    }
}

export const createTaskFail = () => {
    return {
        type: 'CREATETASKFAIL',
    }
}

export const startUpdateTask = () => {
    return {
        type: 'STARTUPDATETASK',
    }
}

export const updateTaskFail = () => {
    return {
        type: 'UPDATETASKFAIL',
    }
}

export const startGetTask = () => {
    return {
        type: 'STARTGETTASK',
    }
}

export const getTaskFail = () => {
    return {
        type: 'GETTASKFAIL',
    }
}

export const taskData = (task) => {
    return {
        type: 'TASKDATA',
        tasks: task,
    }
}

export const startCreateLogRevenue = () => {
    return {
        type: 'STARTCREATELOGREVENUE',
    }
}

export const createLogRevenueFail = () => {
    return {
        type: 'CREATELOGREVENUEFAIL',
    }
}

export const startUpdateLogRevenue = () => {
    return {
        type: 'STARTUPDATELOGREVENUE',
    }
}

export const updateLogRevenueFail = () => {
    return {
        type: 'UPDATELOGREVENUEFAIL',
    }
}

export const startGetLogRevenue = () => {
    return {
        type: 'STARTGETLOGREVENUE',
    }
}

export const getLogRevenueFail = () => {
    return {
        type: 'GETLOGREVENUEFAIL',
    }
}

export const logRevenueData = (revenue) => {
    return {
        type: 'LOGREVENUEDATA',
        loggedRevenues: revenue,
    }
}

export const logRevenueDataForROI = (revenue) => {
    return {
        type: 'LOGREVENUEDATAFORROI',
        loggedRevenuesForROI: revenue,
    }
}

export const logRevenueByIdData = (revenue) => {
    return {
        type: 'LOGREVENUEBYIDDATA',
        revenueById: revenue,
    }
}

export const logRevenueAverage = (revenue) => {
    return {
        type: 'LOGREVENUEAVERAGE',
        averageRevenue: revenue,
    }
}

export const startCreateLogExpense = () => {
    return {
        type: 'STARTCREATELOGEXPENSE',
    }
}

export const createLogExpenseFail = () => {
    return {
        type: 'CREATELOGEXPENSEFAIL',
    }
}

export const startUpdateLogExpense = () => {
    return {
        type: 'STARTUPDATELOGEXPENSE',
    }
}

export const updateLogExpenseFail = () => {
    return {
        type: 'UPDATELOGEXPENSEFAIL',
    }
}

export const startGetLogExpense = () => {
    return {
        type: 'STARTGETLOGEXPENSE',
    }
}

export const getLogExpenseFail = () => {
    return {
        type: 'GETLOGEXPENSEFAIL',
    }
}

export const logExpenseData = (expense) => {
    return {
        type: 'LOGEXPENSEDATA',
        loggedExpenses: expense,
    }
}

export const logExpenseDataForROI = (expense) => {
    return {
        type: 'LOGEXPENSEDATAFORROI',
        loggedExpensesForROI: expense,
    }
}

export const logExpenseByIdData = (expense) => {
    return {
        type: 'LOGEXPENSEBYIDDATA',
        expenseById: expense,
    }
}

export const logExpenseAverage = (expense) => {
    return {
        type: 'LOGEXPENSEAVERAGE',
        averageExpense: expense,
    }
}

export const startRevenueAnalysis = () => {
    return {
        type: 'STARTREVENUEANALYSIS',
    }
}

export const revenueAnalysisFail = () => {
    return {
        type: 'REVENUEANALYSISFAIL',
    }
}

export const revenueAnalysisData = (analysis) => {
    return {
        type: 'REVENUEANALYSISDATA',
        revenueAnalysis: analysis,
    }
}

export const startFetchFeatureFMLinks = () => {
    return {
        type: 'STARTFETCHFEATUREFMLINKS',
    }
}

export const fetchFeatureFMLinksFail = () => {
    return {
        type: 'FETCHFEATUREFMLINKSFAIL',
    }
}

export const fetchFeatureFMLinks = (links) => {
    return {
        type: 'FETCHFEATUREFMLINKS',
        featureFMLinks: links
    }
}

export const startFetchSongstatsData = () => {
    return {
        type: 'STARTFETCHSONGSTATSDATA',
    }
}

export const fetchSongstatsDataFAIL = () => {
    return {
        type: 'FETCHSONGSTATSDATAFAIL',
    }
}

export const fetchSpotifyDataForRevenue = (data) => {
    return {
        type: 'FETCHSPOTIFYDATAFORREVENUE',
        spotifyDataForRevenue: data
    }
}

export const fetchSpotifyDataForROI = (data) => {
    return {
        type: 'FETCHSPOTIFYDATAFORROI',
        spotifyDataForROI: data
    }
}

export const fetchSpotifyDataForAnalysis = (data) => {
    return {
        type: 'FETCHSPOTIFYDATAFORANALYSIS',
        spotifyDataForAnalysis: data
    }
}

export const fetchSpotifyDataForForecast = (data) => {
    return {
        type: 'FETCHSPOTIFYDATAFORFORECAST',
        spotifyDataForForecast: data
    }
}

export const fetchYoutubeDataForRevenue = (data) => {
    return {
        type: 'FETCHYOUTUBEDATAFORREVENUE',
        youtubeDataForRevenue: data
    }
}

export const fetchYoutubeDataForROI = (data) => {
    return {
        type: 'FETCHYOUTUBEDATAFORROI',
        youtubeDataForROI: data
    }
}

export const fetchYoutubeDataForAnalysis = (data) => {
    return {
        type: 'FETCHYOUTUBEDATAFORANALYSIS',
        youtubeDataForAnalysis: data
    }
}

export const fetchYoutubeDataForForecast = (data) => {
    return {
        type: 'FETCHYOUTUBEDATAFORFORECAST',
        youtubeDataForForecast: data
    }
}

export const createNewTask = (toast, body, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startCreateTask());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.post('/artist-manager/task-planner/v1/add-task', body, {
                headers: { Authorization: authCode }
            });
            // showToast('success', response.data.message)
            if (response.data) {
                setIsLoading(false)
                dispatch(fetchAllTasks(toast, setIsLoading));
            }
        } catch (error) {
            dispatch(createTaskFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};

export const fetchAllTasks = (toast, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startGetTask());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/task-planner/v1/get-tasks`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(taskData(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(getTaskFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const updateTask = (toast, taskId, body, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startUpdateTask());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.put(`/artist-manager/task-planner/v1/update-task/${taskId}`, body, {
                headers: { Authorization: authCode }
            });
            showToast('success', response.data.message)
            if (response.data) {
                setIsLoading(false)
                dispatch(fetchAllTasks(toast, setIsLoading));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        } catch (error) {
            dispatch(createTaskFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};

export const createLogRevenue = (toast, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startCreateLogRevenue());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.post('/artist-manager/logs/v1/create-log-revenue', body, {
                headers: { Authorization: authCode }
            });
            if (response.data) {
                // showToast('success', response.data.message)
                await dispatch(fetchLogRevenues(toast, month, year, setIsLoading, "log_revenue"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(createLogRevenueFail());
            handleError(toast, error);
            setIsLoading(false);
        } finally {
            setIsLoading(false)
        }
    };
};

export const fetchLogRevenues = (toast, month, year, setIsLoading, section) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startGetLogRevenue());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-log-revenues?month=${month}&year=${year}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                if (section === "log_revenue") {
                    dispatch(logRevenueData(response.data));
                } else if (section === "roi") {
                    dispatch(logRevenueDataForROI(response.data))
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(getLogRevenueFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const fetchLogRevenueById = (toast, id, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-log-revenue-by-id/${id}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(logRevenueByIdData(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const fetchLogRevenueByPeriod = (toast, period, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-revenue-average?period=${period}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(logRevenueAverage(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const updateLogRevenue = (toast, id, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startUpdateLogRevenue());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.put(`/artist-manager/logs/v1/update-log-revenue/${id}`, body, {
                headers: { Authorization: authCode }
            });
            if (response.data) {
                // showToast('success', response.data.message)
                await dispatch(fetchLogRevenues(toast, month, year, setIsLoading, "log_revenue"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(updateLogRevenueFail());
            handleError(toast, error);
            setIsLoading(false);
        } finally {
            setIsLoading(false)
        }
    };
};

export const deleteLogRevenue = (toast, id, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.delete(`/artist-manager/logs/v1/delete-log-revenue/${id}`, {
                headers: { Authorization: authCode }
            });
            if (response.data) {
                // showToast('success', response.data.message)
                await dispatch(fetchLogRevenues(toast, month, year, setIsLoading, "log_revenue"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            handleError(toast, error);
            setIsLoading(false);
        } finally {
            setIsLoading(false)
        }
    };
};

export const createLogExpense = (toast, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startCreateLogExpense());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.post('/artist-manager/logs/v1/create-log-expense', body, {
                headers: { Authorization: authCode }
            });
            if (response.data) {
                // showToast('success', response.data.message)
                await dispatch(fetchLogExpenses(toast, month, year, setIsLoading, "log_expense"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(createLogExpenseFail());
            setIsLoading(false)
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};

export const fetchLogExpenses = (toast, month, year, setIsLoading, section) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startGetLogExpense());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-log-expenses?month=${month}&year=${year}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                if (section === "log_expense") {
                    dispatch(logExpenseData(response.data));
                } else if (section === "roi") {
                    dispatch(logExpenseDataForROI(response.data))
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(getLogExpenseFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const fetchLogExpenseById = (toast, id, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-log-expense-by-id/${id}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(logExpenseByIdData(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const fetchLogExpenseByPeriod = (toast, period, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-expense-average?period=${period}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(logExpenseAverage(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
}

export const updateLogExpense = (toast, id, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startUpdateLogExpense());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.put(`/artist-manager/logs/v1/update-log-expense/${id}`, body, {
                headers: { Authorization: authCode }
            });
            // showToast('success', response.data.message)
            if (response.data) {
                await dispatch(fetchLogExpenses(toast, month, year, setIsLoading, "log_expense"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(updateLogExpenseFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};

export const deleteLogExpense = (toast, id, body, month, year, setIsLoading, onSuccess) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.delete(`/artist-manager/logs/v1/delete-log-expense/${id}`, {
                headers: { Authorization: authCode }
            });
            if (response.data) {
                await dispatch(fetchLogExpenses(toast, month, year, setIsLoading, "log_expense"));
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(updateLogExpenseFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};

export const fetchRevenueAnalysis = (toast, duration, revenues, expenses, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startRevenueAnalysis());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-revenue-analysis?duration=${duration}&estimatedRevenues=${revenues}&estimatedExpenses=${expenses}`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(revenueAnalysisData(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(revenueAnalysisFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    }
}

export const fetchSmartLinks = (toast, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startFetchFeatureFMLinks());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/logs/v1/get-feature-fm-links`, {
                headers: { Authorization: authCode },
            });
            if (response.data) {
                dispatch(fetchFeatureFMLinks(response.data));
                setIsLoading(false)
            }
        } catch (error) {
            dispatch(fetchFeatureFMLinksFail());
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    }
}

export const getStreamsData = (toast, queryParams, setIsLoading, section) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startFetchSongstatsData());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-streams-by-durations', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            if (queryParams.source === "spotify") {
                if (section === "log_revenue") {
                    dispatch(fetchSpotifyDataForRevenue(response.data))
                } else if (section === "roi") {
                    dispatch(fetchSpotifyDataForROI(response.data))
                } else if (section === "analysis") {
                    dispatch(fetchSpotifyDataForAnalysis(response.data))
                } else if (section === "forecast") {
                    dispatch(fetchSpotifyDataForForecast(response.data))
                }
            }
            if (queryParams.source === "youtube") {
                if (section === "log_revenue") {
                    dispatch(fetchYoutubeDataForRevenue(response.data))
                } else if (section === "roi") {
                    dispatch(fetchYoutubeDataForROI(response.data))
                } else if (section === "analysis") {
                    dispatch(fetchYoutubeDataForAnalysis(response.data))
                } else if (section === "forecast") {
                    dispatch(fetchYoutubeDataForForecast(response.data))
                }
            }
            setIsLoading(false)
        } catch (error) {
            dispatch(fetchSongstatsDataFAIL());
            handleError(toast, error);
        }
    };
};

export const getStremingStoreData = (list) => {
    return {
        type: 'GETSTREMINGSTORE',
        list: list,
    }
};

export const getStremingStore = (data) => {
    return async (dispatch) => {
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/artist-manager/v1/get-song-store`, {
                headers: { Authorization: authCode },
                params: data,
            });
            if (response.status === 200) {
                dispatch(getStremingStoreData(response?.data?.stores));
            }
        } catch (error) {
            showToast('error', error?.response?.data?.message || error.message)
        }
    };
};


